export default __webpack_public_path__ + "static/media/Defect Collage.48a0b851.png";